import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";
import store from "../store";
import { AppState } from "../reducers";

export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();

export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
